import { render } from "./FeaturedAgencies.vue?vue&type=template&id=3bb22d04&scoped=true"
import script from "./FeaturedAgencies.vue?vue&type=script&lang=js"
export * from "./FeaturedAgencies.vue?vue&type=script&lang=js"

import "./FeaturedAgencies.vue?vue&type=style&index=0&id=3bb22d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb22d04"]])

export default __exports__